<mat-card>
   <form #loginForm="ngForm">
   <mat-toolbar>
    {{'dedicacions.titol' | translate }} ({{userInfo.name}})
    <div style="width:100%;float:right">
      <button mat-icon-button style="float: right; margin-left: 5px" (click)="close()" matTooltip="{{('dedicacions.tancar') | translate}}" attr.aria-label="{{('dedicacions.tancar') | translate}}" matTooltipClass="tooltip-style">
          <mat-icon color="primary" style="font-size:24px">close</mat-icon>
        </button>
    </div>
   </mat-toolbar>
   <mat-progress-bar mode="indeterminate" color="warm" *ngIf="showAsyncProgress" style="position: absolute;"></mat-progress-bar>
   <mat-card-content style="float: left;clear: both;padding: 24px;padding-bottom:0px;width:80%">
      <mat-checkbox style="float: left;clear: none;margin-left: 1em;" name="tip2" [checked]= "esPreproposta" [disabled]="true">
         {{'dedicacions.chkmanifestacio' | translate}}
      </mat-checkbox>
      <mat-checkbox style="float: left;clear: none;margin-left: 1em;" name="tip1" [checked]= "esProposta" [disabled]="true">
         {{'dedicacions.chkpro' | translate}}
      </mat-checkbox>
      <mat-checkbox style="float: left;clear: none;margin-left: 1em;" name="tip0" [checked]= "esProjecte" [disabled]="true">
        {{'dedicacions.chktreball' | translate}}
      </mat-checkbox>
      <mat-form-field style="float: left;clear: none;width:80%;padding-top:20px;color:black">
        <input matInput type="text" (ngModelChange)="tbCodis = filterStates($event)"
           [(ngModel)]="codi" name="codi" placeholder="{{ 'propostaMi.camps.codi' | translate }}" [matAutocomplete]="auto" disabled>
        <mat-autocomplete #auto="matAutocomplete">
          <mat-option *ngFor="let codi of tbCodis" [value]="codi.codi">{{codi.nom}}</mat-option>
        </mat-autocomplete>
      </mat-form-field>
      <button color="primary" mat-icon-button matTooltip="{{ 'dedicacionsDialog.filtrarHoresToolTip' | translate }}" attr.aria-label="{{ 'dedicacionsDialog.filtrarHoresToolTip' | translate }}" matTooltipClass="tooltip-style" (click)="requestRowsToParent()" style="display: none; float: left;clear: none;margin-left: 20px;width:30px;padding-top:20px">
         <mat-icon style="font-size:24px;font-weight:bold">done</mat-icon>
      </button>
    </mat-card-content>
    <mat-card-content style="float:left;clear:both;padding:24px;padding-bottom:0px;padding-top:0px;width:95%">
      <mat-form-field style="float:left;clear:left;margin: 0px;width:0px">
        <input matInput name="id" [(ngModel)]="editDedicacionsData.id" ngDefaultControl/>
      </mat-form-field> 
      <mat-form-field style="float: left;none: left;width:130px">
        <input matInput placeholder="{{ 'dedicacionsDialog.dataIniciPlaceholder' | translate }}" name="inici" type="date" [(ngModel)]="editDedicacionsData.inici" ngDefaultControl (change)="cnvDts()" />
      </mat-form-field> 
      <mat-form-field style="float: left;clear: none;width:130px;margin-left:20px">
        <input matInput placeholder="{{ 'dedicacionsDialog.dataFiPlaceholder' | translate }}" name="fi" type="date" [(ngModel)]="editDedicacionsData.fi" ngDefaultControl (change)="cnvDts()"/>
      </mat-form-field>
      <mat-form-field style="float: left;clear: none;width:60px;margin-left:20px;color:black">
        <input matInput type="number" min="0" max="100" step="1" placeholder="{{ 'dedicacionsDialog.percentHoresPlaceholder' | translate }}" style="width:100%" name="'percent'" [ngModel]="editDedicacionsData.percent | number:'1.2-2'" ngDefaultControl disabled title="{{ 'dedicacionsDialog.percentHoresTitle' | translate }}"/>
      </mat-form-field>
      <mat-form-field style="float: left;clear: none;width:85px;margin-left:20px;color:black">
        <input matInput type="number" step="1" placeholder="{{ 'dedicacionsDialog.horesAssignadesPlaceholder' | translate }}" style="width:90%" name="'hores_periode'" [ngModel]="hores_periode" ngDefaultControl disabled title="{{ 'dedicacionsDialog.horesAssignadesTitle' | translate }}"/>
        <mat-icon style="float: right; clear: none;font-size:16px;width:8%;height: 10px;font-weight:bold;color:#3f51b5;cursor:pointer" (click)="llistarHoresProj()" title="{{ 'dedicacionsDialog.mostrarDistribucioTitle' | translate }}">description</mat-icon>
      </mat-form-field>

<table mat-table [dataSource]="dataSource" class="mat-elevation-z8" [hidden]= "horesProjHidden" (click)="llistarHoresProj()">
  <mat-text-column name="codi"></mat-text-column>
  <mat-text-column name="hores"></mat-text-column>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>

      <mat-form-field style="float: left;clear: none;width:60px;margin-left:20px">
        <input matInput type="number" min="0" step="0.1" placeholder="{{ 'dedicacions.colHores' | translate }}" style="width:100%" name="'hores'" [(ngModel)]="editDedicacionsData.hores" ngDefaultControl (keyup)="cnvHores()" title="{{ 'dedicacionsDialog.horesPendentsTitle' | translate }}"/>
      </mat-form-field>
      <mat-form-field style="float: left;clear: none;width:240px;margin-left:20px">
        <input matInput placeholder="{{ 'dedicacions.colDescripcio' | translate }}" name="'description'" style="width:100%" [(ngModel)]="editDedicacionsData.descripcio" ngDefaultControl/>
      </mat-form-field>
      <button color="primary" mat-icon-button matTooltip="{{ 'common.desar' | translate }}" attr.aria-label="{{ 'common.desar' | translate }}" matTooltipClass="tooltip-style" (click)="desar()" style="float: left;clear: none;margin-left: 0px;width:50px">
         <mat-icon style="font-size:24px;font-weight:bold">note_add</mat-icon>
      </button>
      <div style="float: left;clear: both;width: 100%">
      <sup>*</sup>&nbsp;{{ 'dedicacionsDialog.notaPercent' | translate }}</div>
    </mat-card-content>
    <mat-card-content style="padding: 24px;padding-bottom:0px;float: left;clear: both;width: 100%" *ngIf="dedicacionsData">
     <h2 style="float: left;clear: both">{{'dedicacions.taula' | translate}}</h2>
     <div style="float: left;clear: both;max-height:200px;width: 95%;overflow-y:scroll">
     <table style="float: left;clear: both;padding-top: 0px;width: 95%">
      <thead mat-head>
        <tr style="border-bottom:1px solid #888">
          <th style="width:0%;text-align: left" mat-column>{{ 'utes.cmpid' | translate }}</th>
          <th style="width:50%;text-align: left" mat-column>{{'dedicacions.colDescripcio' | translate}}</th>
          <th style="width:10%;text-align: left" mat-column>{{'dedicacions.colHores' | translate}}</th>
          <th style="width:15%;text-align: left" mat-column>{{'dedicacions.colInici' | translate}}</th>
          <th style="width:15%;text-align: left" mat-column>{{'dedicacions.colFi' | translate}}</th>
          <th style="width:10%;text-align: left" mat-column>{{'dedicacions.operacions' | translate}}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let dades of dedicacionsData; let i = index" style="cursor:pointer">
          <td style="text-align:left">
            {{dades.id}}
          </td>
          <td style="text-align:left">
              <div style='font-size:1em' matTooltip="{{dades.descripcio}}" attr.aria-label="{{dades.descripcio}}" matTooltipClass="tooltip-style">
              {{dades.descripcio}}</div>
          </td>
          <td style="text-align:left">
            {{dades.hores}}
          </td>
          <td style="text-align:left">
            {{dades.inici}}
          </td>
          <td style="text-align:left">
            {{dades.fi}}
          </td>
          <td style="text-align:left">
            <button mat-icon-button style="float: right; width:30px; margin-right: 0" (click)="editar(i)" matTooltip="{{ 'dedicacionsDialog.editarHoresToolTip' | translate }}" attr.aria-label="{{ 'dedicacionsDialog.editarHoresToolTip' | translate }}" matTooltipClass="tooltip-style">
              <mat-icon color="primary" style="font-size:24px">edit</mat-icon>
            </button>
            <button mat-icon-button style="float: right; width:30px; margin-right: 0" (click)="esborrar(dades.id, i)" matTooltip="{{ 'dedicacionsDialog.esborrarHoresToolTip' | translate }}" attr.aria-label="{{ 'dedicacionsDialog.esborrarHoresToolTip' | translate }}" matTooltipClass="tooltip-style">
               <mat-icon color="primary" style="font-size:24px">delete_forever</mat-icon>
            </button>
          </td>
        </tr> 
      </tbody>
    </table>
  </div>
   </mat-card-content>
 </form>
</mat-card>
